import './WizardBottomPanel.css';
import React from 'react';
import { ReactComponent as LeftButtonChevron } from '../../../resources/icons/leftButtonChevron.svg';
import RouterLink from '../RouterLink';
export var WizardBottomPanel = function WizardBottomPanel(_ref) {
  var rtl = _ref.rtl,
    backLabel = _ref.backLabel,
    nextLabel = _ref.nextLabel,
    nextHref = _ref.nextHref,
    isNextDisabled = _ref.isNextDisabled,
    onNextClick = _ref.onNextClick,
    onBackClick = _ref.onBackClick;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, /*#__PURE__*/React.createElement("button", {
    onClick: onBackClick,
    className: "wizard-bottom-panel__prev-btn"
  }, /*#__PURE__*/React.createElement(LeftButtonChevron, {
    className: "wizard-bottom-panel__prev-btn-icon"
  }), /*#__PURE__*/React.createElement("span", {
    className: "wizard-bottom-panel__prev-btn-title"
  }, backLabel)), nextHref && !isNextDisabled ? /*#__PURE__*/React.createElement(RouterLink, {
    className: "btn btn-primary wizard-bottom-panel__btn",
    href: nextHref,
    onClick: function onClick() {
      onNextClick();
    }
  }, nextLabel) : /*#__PURE__*/React.createElement("button", {
    disabled: isNextDisabled,
    className: "btn btn-primary wizard-bottom-panel__btn",
    onClick: onNextClick
  }, nextLabel));
};
var MAX_MOBILE_WIDTH = "767px";
var commonStyles = "c18vli6t";
var rtlStyles = "rd94j3x";
var ltrStyles = "l1dy2fu8";